import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wqmd5mntt6: FaireBrandEntity = {
  token: "b_wqmd5mntt6",
  type: "brand",
  name: "Womaness",
  avatarUrl:
    "https://cdn.faire.com/fastly/7f1ecb0afeae4af1a2b927de53ededb26ef0d56c4d81a582980e5379a193b8bf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/686d324e4a8e89836ff5146d65114c191ed8b0d6a1a8fdef7918a738073ed0b1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7f1ecb0afeae4af1a2b927de53ededb26ef0d56c4d81a582980e5379a193b8bf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/686d324e4a8e89836ff5146d65114c191ed8b0d6a1a8fdef7918a738073ed0b1.png",
  location: "Lake Elmo, MN, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Menopause, Meet Your Match: Womaness is a high-performance collection of modern menopause products created by women for women that offer solutions from head to toe (and everything in between). We don’t want anything to stop us—that includes hot flashes, dry skin, and sleepless nights. Through innovative products, essential information, and unlimited inspiration, Womaness takes the “pause” out of menopause and sparks the power of menopositivity: a radiant, dynamic outlook that embraces who we are today.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:40.336Z",
    importedBy: "entity-db-cli",
  },
};
